import { Component, Input, OnInit } from '@angular/core';
import { FormControl, NG_VALUE_ACCESSOR } from '@angular/forms';

import { FormControlComponent } from '../../../abstracts/form-control.abstract';
import { BasicInputTypeEnum } from '../../../enums/basic-input-type.enum';
import { IPasswordInputConfig } from '../../../interfaces/password-input-config.interface';

@Component({
    selector: 'app-password-input',
    templateUrl: './password-input.component.html',
    styleUrls: ['./password-input.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: PasswordInputComponent,
            multi: true,
        },
    ],
})
export class PasswordInputComponent extends FormControlComponent implements OnInit {
    @Input() public inputConfig: IPasswordInputConfig;

    @Input() public isValid = true;

    @Input() public classes = '';

    public placeholder: string;
    public inputId: string;
    public type = BasicInputTypeEnum.PASSWORD;
    public showPassword = false;

    public inputControl = new FormControl();

    constructor() {
        super();
    }

    ngOnInit(): void {
        this.placeholder = this.inputConfig.placeholder;
        this.inputId = this.inputConfig.inputId;
    }

    public writeValue(obj: any): void {
        this.value = obj;
        this.inputControl.patchValue(obj);
    }

    public onInput(): void {
        if (this.disabled) {
            return;
        }

        this.value = this.inputControl.value;

        this.onChange(this.value);
        if (!this.touched) {
            this.onTouched();
        }
    }

    public toggleInputType(): void {
        this.type = this.type === BasicInputTypeEnum.PASSWORD ? BasicInputTypeEnum.TEXT : BasicInputTypeEnum.PASSWORD;
        this.showPassword = !this.showPassword;
    }
}
